// 订单码洋同比模块
const state = {
  // 订单数及码洋同比
  orderComparison: {
    dates: [],
    orders: [],
    amounts: [],
    compareYears: []
  }
}

const mutations = {
  // 设置订单码洋同比数据
  SET_ORDER_COMPARISON(state, data) {
    state.orderComparison = data
  },
  // 重置订单码洋同比数据
  RESET_ORDER(state) {
    state.orderComparison = {
      dates: [],
      orders: [],
      amounts: [],
      compareYears: []
    }
  }
}

const actions = {
  // 获取订单码洋同比数据（使用大屏 dingdan 字段派生：以数据中最新年份zhou字段作为基准x轴点，仅匹配zhou_2字段中同期数据）
  async fetchOrderComparison({ commit, rootState }) {
    try {
      const big = rootState.screen.screenData || {}
      const list = Array.isArray(big.dingdan) ? big.dingdan : []
      const safeNum = (v) => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }

      const yearData = new Map() // year -> Map(zhou -> { amount, orders, week2 })
      const week2Data = new Map() // year -> Map(week2 -> { amount, orders })

      for (const item of list) {
        const year = Number(item?.nian)
        const week = Number(item?.zhou)
        const week2 = Number(item?.zhou_2)
        
        if (!year) continue

        if (!yearData.has(year)) {
          yearData.set(year, new Map())
        }
        if (!week2Data.has(year)) {
          week2Data.set(year, new Map())
        }

        if (week) {
          yearData.get(year).set(week, {
            amount: safeNum(item?.mayang),
            orders: safeNum(item?.sl),
            week2
          })
        }

        if (week2) {
          week2Data.get(year).set(week2, {
            amount: safeNum(item?.mayang),
            orders: safeNum(item?.sl)
          })
        }
      }

      const years = Array.from(yearData.keys()).sort((a, b) => b - a)
      const baselineYear = years[0] || new Date().getFullYear()
      const compareYear = baselineYear - 1

      const baselineWeeks = yearData.get(baselineYear) || new Map()
      const compareWeekData = week2Data.get(compareYear) || new Map()

      const isoWeekMonday = (year, week) => {
        const jan4 = new Date(Date.UTC(year, 0, 4))
        const jan4Dow = (jan4.getUTCDay() + 6) % 7
        const mondayWeek1 = new Date(jan4)
        mondayWeek1.setUTCDate(jan4.getUTCDate() - jan4Dow)
        const mondayOfWeek = new Date(mondayWeek1)
        mondayOfWeek.setUTCDate(mondayWeek1.getUTCDate() + (week - 1) * 7)
        return mondayOfWeek
      }
      const fmt = (d) => {
        const y = d.getUTCFullYear()
        const m = d.getUTCMonth() + 1
        const day = d.getUTCDate()
        return `${y}.${m}.${day < 10 ? '0' + day : day}`
      }

      const sortedWeeks = Array.from(baselineWeeks.keys()).sort((a, b) => a - b)
      const dates = []
      const orders = []
      const amounts = []
      const compareYears = []
      
      for (const week of sortedWeeks) {
        const currentData = baselineWeeks.get(week)
        const matchWeek2 = currentData?.week2
        const lastData = matchWeek2 ? compareWeekData.get(matchWeek2) : null
        
        if (currentData) {
          const startMon = isoWeekMonday(baselineYear, week)
          const endSun = new Date(startMon)
          endSun.setUTCDate(startMon.getUTCDate() + 6)
          dates.push(`${fmt(startMon)}~${fmt(endSun)}`)
          compareYears.push(compareYear)
          
          orders.push({ 
            currentYear: currentData.orders, 
            lastYear: lastData ? lastData.orders : 0 
          })
          amounts.push({ 
            currentYear: currentData.amount, 
            lastYear: lastData ? lastData.amount : 0 
          })
        }
      }

      commit('SET_ORDER_COMPARISON', { dates, orders, amounts, compareYears })
    } catch (error) {
      console.error('获取订单码洋同比数据失败:', error)
      commit('SET_ORDER_COMPARISON', { dates: [], orders: [], amounts: [], compareYears: [] })
    }
  }
}

const getters = {
  orderComparison: state => state.orderComparison
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
